import {
  compose,
  endsWith,
  filter,
  find,
  flatten,
  length,
  map,
  path,
  pathEq,
  prop,
  propEq
} from "ramda";
import { getMaarayksetByTunniste } from "@/helpers/lupa";
import {
  createMaarayksiaVastenLuodutRajoitteetDynaamisilleTekstikentilleBEObjects,
  getRajoitteetByValueStartsWith
} from "@/utils/rajoitteetUtils";
import {
  createBECheckboxChangeObjectsForDynamicTextBoxes,
  createDynamicTextBoxBeChangeObjects
} from "@/services/lomakkeet/dynamic";
import { luoMuutosobjektitLisatietokentasta } from "@/helpers/lisatiedot";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";

export const defineBackendChangeObjects = async (
  changeObjects = [],
  maaraystyypit,
  lupaMaaraykset,
  locale,
  kohteet
) => {
  const maaraykset = await getMaarayksetByTunniste(
    "muutkoulutuksenjarjestamiseenliittyvatehdot",
    lupaMaaraykset
  );

  const { rajoitteetByRajoiteId } = changeObjects;

  const kohde = find(
    propEq("tunniste", "muutkoulutuksenjarjestamiseenliittyvatehdot"),
    kohteet
  );
  const maaraystyyppi = find(propEq("tunniste", "OIKEUS"), maaraystyypit);
  const muutEhdot =
    (await localForage.getItem(
      PaikallisenTietovarastonAvain.LUKIO_MUUT_EHDOT
    )) || [];

  const muutokset = map(ehto => {
    // Checkbox-kenttien muutokset
    const checkboxChangeObj = find(
      compose(endsWith(`.${ehto.koodiarvo}.valintaelementti`), prop("anchor")),
      changeObjects.muutEhdot
    );

    // Kuvauskenttien muutokset kohdassa (muu ehto)
    const kuvausChangeObjects = filter(changeObj => {
      return (
        ehto.koodiarvo ===
          path(["metadata", "koodiarvo"], changeObj.properties) &&
        endsWith(".kuvaus", changeObj.anchor)
      );
    }, changeObjects.muutEhdot);

    let checkboxBEchangeObject = null;
    let kuvausBEchangeObjects = [];

    const rajoitteetByRajoiteIdAndKoodiarvo = getRajoitteetByValueStartsWith(
      `${ehto.koodiarvo}-`,
      rajoitteetByRajoiteId
    );

    const ehtoonLiittyvatMaaraykset = filter(
      m =>
        propEq("koodiarvo", ehto.koodiarvo, m) &&
        propEq(
          "koodisto",
          "lukiomuutkoulutuksenjarjestamiseenliittyvatehdot",
          m
        ),
      maaraykset
    );

    const isCheckboxChecked =
      (!!ehtoonLiittyvatMaaraykset.length && !checkboxChangeObj) ||
      (checkboxChangeObj &&
        pathEq(["properties", "isChecked"], true, checkboxChangeObj));

    if (length(kuvausChangeObjects) && isCheckboxChecked) {
      kuvausBEchangeObjects = createDynamicTextBoxBeChangeObjects(
        kuvausChangeObjects,
        ehtoonLiittyvatMaaraykset,
        isCheckboxChecked,
        ehto,
        maaraystyyppi,
        maaraystyypit,
        rajoitteetByRajoiteIdAndKoodiarvo,
        checkboxChangeObj,
        kohde,
        kohteet
      );
    } else {
      return createBECheckboxChangeObjectsForDynamicTextBoxes(
        checkboxChangeObj,
        ehto,
        rajoitteetByRajoiteIdAndKoodiarvo,
        kohteet,
        kohde,
        maaraystyypit,
        maaraystyyppi,
        ehtoonLiittyvatMaaraykset,
        isCheckboxChecked,
        locale,
        "muuEhto"
      );
    }

    return [checkboxBEchangeObject, kuvausBEchangeObjects];
  }, muutEhdot);

  const lisatietomuutokset = await luoMuutosobjektitLisatietokentasta(
    kohde,
    changeObjects.muutEhdot,
    maaraystyyppi
  );

  const maarayksiaVastenLuodutRajoitteet =
    createMaarayksiaVastenLuodutRajoitteetDynaamisilleTekstikentilleBEObjects(
      maaraykset,
      rajoitteetByRajoiteId,
      kohteet,
      maaraystyypit,
      kohde
    );

  return flatten([
    lisatietomuutokset,
    muutokset,
    maarayksiaVastenLuodutRajoitteet
  ]).filter(Boolean);
};
